import request from '@/request/request'
import html2canvas from 'html2canvas'
export async function printscreen(examId, subjectType, subjectiveItemId, studentId) {
    if (!document.body) return Promise.reject('document.body不存在')
    try {
        let canvas = await html2canvas(document.body, {
            scale: 2,
            backgroundColor: '#ffffff',
        })

        // 将 toBlob 封装成 Promise
        const blob = await new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve(blob)
                } else {
                    reject(new Error('生成 Blob 失败'))
                }
            }, 'image/png')
        })

        let file = new File([blob], 'screenshot.png', { type: 'image/png' })
        let formData = new FormData()
        formData.append('examId', examId)
        formData.append('subjectType', subjectType)
        formData.append('subjectiveItemId', subjectiveItemId)
        formData.append('studentId', studentId)
        formData.append('screenShotFile', file) // 注意：直接传 file，不是 file.raw

        const res = await request.instance({
            url: '/Paper/MarkingTeacher/UploadScreenShotFile',
            method: 'post',
            data: formData,
        })

        return res

    } catch (error) {
        console.error('截图上传失败:', error)
        throw error  // 抛出错误让调用方处理
    }
}